// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Typography Utilities */

/* Material Symbols filled */
.material-symbols-outlined.filled {
  font-variation-settings: 'FILL' 1;
}

/* App Title */
.app-title {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: var(--text-primary);
}

.app-title.large {
  font-size: 1.5rem;
  line-height: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/base/typography.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,4BAA4B;AAC5B;EACE,iCAAiC;AACnC;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":["/* Typography Utilities */\n\n/* Material Symbols filled */\n.material-symbols-outlined.filled {\n  font-variation-settings: 'FILL' 1;\n}\n\n/* App Title */\n.app-title {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: var(--text-primary);\n}\n\n.app-title.large {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
